import { useLocale } from '../../application/i18n/LocaleProvider';
import { BellIcon } from '../icons/ControlIcons';

/**
 * The offer to be told when a plant joins the catalogue (SPEC-016).
 *
 * The same non-blocking shape as the install card, for the same reason, and with
 * one extra rule of its own: this card is the ONLY thing in the app that may
 * call `Notification.requestPermission()`. The browser grants that call once in
 * any meaningful sense — a visitor who answers "block" cannot be asked again by
 * anything the page controls — so it happens behind a button whose label says
 * what pressing it will do, and never on load.
 *
 * What it promises is deliberately small and deliberately exact: a new plant,
 * and nothing else. There is no digest, no re-engagement nudge and no second
 * category that could later be added under the same permission.
 */
export default function NotificationOfferCard({ onEnable, onDismiss }) {
    const { t } = useLocale();

    return (
        <section className="app-offer" aria-labelledby="notify-offer-title">
            <span className="app-offer__mark" aria-hidden="true">
                <BellIcon size={26} />
            </span>

            <h2 className="app-offer__title" id="notify-offer-title">{t('pwa.notify.title')}</h2>
            <p className="app-offer__body">{t('pwa.notify.body')}</p>

            {/* The limit, stated rather than implied away — as the My Garden
                screen states its own (SPEC-014 D-5). This device, not this
                gardener: there is no account to attach a subscription to. */}
            <p className="app-offer__note">{t('pwa.notify.deviceNote')}</p>

            <div className="app-offer__actions">
                <button type="button" className="button button--primary" onClick={onEnable}>
                    {t('pwa.notify.action.enable')}
                </button>
                <button type="button" className="app-offer__dismiss" onClick={onDismiss}>
                    {t('pwa.notify.dismiss')}
                </button>
            </div>
        </section>
    );
}
